import React, { useState, useEffect } from 'react';
import * as api from '../../services/api';
import { SystemsChart, VerbsChart } from './StatsCharts';
import Loading from '../layout/Loading';

import {
    Container,
    Typography,
    Box,
    Grid,
    Card,
    CardHeader,
    CardContent,
    List,
    ListItem,
    ListItemText,
    Divider,
    Alert,
} from '@mui/material';

const Dashboard = () => {
    const [stats, setStats] = useState({
        perSystem: [],
        frequentVerbs: [],
        topActors: [],
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchAllStats = async () => {
            try {
                const [perSystemRes, frequentVerbsRes, topActorsRes] = await Promise.all([
                    api.getStatsPerSystem(),
                    api.getMostFrequentVerbs(),
                    api.getTopActors(),
                ]);
                setStats({
                    perSystem: perSystemRes.data,
                    frequentVerbs: frequentVerbsRes.data,
                    topActors: topActorsRes.data,
                });
            } catch (err) {
                console.error('Fehler beim Laden der Dashboard‑Daten:', err);
                setError('Statistiken konnten nicht geladen werden.');
            } finally {
                setLoading(false);
            }
        };

        fetchAllStats();
    }, []);

    if (loading) {
        return <Loading text="Lade Statistiken…" />;
    }

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                xAPI Dashboard
            </Typography>

            {error && (
                <Alert severity="error" sx={{ mb: 3 }}>
                    {error}
                </Alert>
            )}

            <Grid container spacing={2}>
                {/* Statements pro Quellsystem */}
                <Grid size={{ xs: 12, md: 6 }}>
                    <Card>
                        <CardHeader title="Statements pro Quellsystem" />
                        <CardContent>
                            <SystemsChart data={stats.perSystem} />
                        </CardContent>
                    </Card>
                </Grid>

                {/* Häufigste Aktionen (Verben) */}
                <Grid size={{ xs: 12, md: 6 }}>
                    <Card>
                        <CardHeader title="10 Häufigste Aktionen (Verben)" />
                        <CardContent>
                            <VerbsChart data={stats.frequentVerbs} />
                        </CardContent>
                    </Card>
                </Grid>

                {/* Top 10 aktivste Nutzer */}
                <Grid size={{ xs: 12, md: 6 }}>
                    <Card>
                        <CardHeader title="Top 10 aktivste Nutzer" />
                        <CardContent>
                            <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                                <List dense>
                                    {stats.topActors.map((actor, idx) => (
                                        <React.Fragment key={actor.name}>
                                            <ListItem>
                                                <ListItemText primary={actor.name} />
                                                <Typography variant="body2" color="text.secondary">
                                                    {actor.count}
                                                </Typography>
                                            </ListItem>
                                            {idx < stats.topActors.length - 1 && <Divider component="li" />}
                                        </React.Fragment>
                                    ))}
                                </List>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Dashboard;
